export default {"src":"/_next/static/media/lawn-installation-grass.67272a1c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};